export default __webpack_public_path__ + "static/media/s6.bf9a0096.jpg";